import React from 'react';
import { Button, AccordionButton, AccordionItem } from '@chakra-ui/react';

const LogoutButton = ({ onLogout = () => {}, isMobile = false }) => {
  if (isMobile) {
    return (
      <AccordionItem id="nav-drop-mobile-for-logout" border="none" color="#fff">
        <AccordionButton
          fontSize="2xl"
          fontFamily="heading"
          py="5px"
          color="#fff"
          background="none"
          border="none"
          _hover={{ color: `secondary.pink`, background: `none` }}
          onClick={onLogout}>
          Log Out
        </AccordionButton>
      </AccordionItem>
    );
  }
  return (
    <Button
      display="flex"
      h="14"
      color="primary.dark-blue"
      fontFamily="heading"
      fontWeight="600"
      lineHeight="1.2"
      borderRadius="xs"
      transition="color .2s"
      _hover={{ color: `secondary.pink` }}
      onClick={onLogout}
      sx={{ span: { alignSelf: `center` } }}>
      Log Out
    </Button>
  );
};
export default LogoutButton;
